import { normalAOP } from '../common';
import Cookies from 'cookies-js'
Cookies.set = normalAOP(
  Cookies.set,
  (...args: any) => {
    // console.log('use ynf-core-middleware before,params:' + args);
  },
  () => {
    // console.log('ynf-core-middleware after');
  }
);
export default Cookies;
